<!-- eslint-disable max-len -->
<template>
  <div>
    <header-bar>登録情報</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アカウント情報</h3>
      </div>
      <div class="page-block__inner">
        <div class="profile-heading">
          <div class="profile-heading__btn">
            <router-link
              :to="{ name: 'profile-edit' }"
              class="c-btn c-btn--edit c-btn--with-icon">
              <img
                src="/img/common/icon-edit_white.png"
                alt="">
              登録情報を編集する
              <span class="c-btn__icon-arrow"></span>
            </router-link>
          </div>
          <div class="profile-label">アカウント画像</div>
          <div class="profile-heading__wrap">
            <div class="profile-heading__pic">
              <img
                v-if="item.avatar_path"
                :src="`/images/${item.avatar_path}`">
            </div>
            <div class="profile-heading__name">
              {{ item.company.is_consumer ? item.name : item.company.name }}
            </div>
          </div>
        </div>
        <div class="profile-info">
          <form>
            <div class="form-wrap form-wrap--profile">
              <div
                v-if="isBtoC"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">ご契約プラン</label>
                </div>
                <div
                  v-if="item.is_scholarship===1"
                  class="form-item form-item--change-btn">
                  サブスクプラン (スカラーシップ)
                </div>
                <div
                  v-else
                  class="form-item form-item--change-btn">
                  {{ contract_plan_name }}
                  <a
                    v-if="contract_plan === 2"
                    class="c-btn c-btn--narrow"
                    @click.prevent="onClickGoToCancel">
                    解約する
                    <span class="c-btn__icon-arrow"></span>
                  </a>
                </div>
              </div>
              <div
                v-if="isSubscriber || subscriptionDefaulted || subscriptionCarrierFeePending"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">決済手段</label>
                </div>
                <div
                  v-if="item.is_scholarship===1"
                  class="form-item form-item--change-btn">
                </div>
                <div
                  v-else
                  class="form-item form-item--change-btn">
                  {{ settlement_method }}
                  <router-link
                    v-if="item.is_scholarship!==1"
                    :to="{ name: 'settlement-method-change' }"
                    class="c-btn c-btn--narrow">
                    変更する
                    <span class="c-btn__icon-arrow"></span>
                  </router-link>
                </div>
              </div>
              <div
                v-if="isBtoC"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">ご利用明細</label>
                </div>
                <div
                  class="form-item form-item--change-btn">
                  <router-link
                    :to="{ name: 'usage-statement'}"
                    class="c-btn c-btn--narrow">
                    詳細を見る
                    <span class="c-btn__icon-arrow"></span>
                  </router-link>
                </div>
              </div>
              <div
                v-if="isBtoB"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">法人名</label>
                </div>
                <div
                  class="form-item">
                  {{ item.company.name }}
                </div>
              </div>
              <div
                v-if="isBtoB"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">代表者名</label>
                </div>
                <div
                  class="form-item">
                  {{ item.company.representative_name }}
                </div>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label class="control-label">
                    {{ isBtoB ? '担当者名': 'アカウント管理者氏名' }}
                  </label>
                </div>
                <div
                  class="form-item">
                  {{ item.company.contact_name }}
                </div>
              </div>
              <div
                v-if="isBtoC && item.dob"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">
                    生年月日
                  </label>
                </div>
                <div
                  class="form-item">
                  {{ item.dob }}
                </div>
              </div>
              <div
                v-if="isBtoB"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">電話番号</label>
                </div>
                <div
                  class="form-item">
                  {{ item.company.telephone }}
                </div>
              </div>
              <div
                v-if="isBtoC && item.mobile_number"
                class="form-group">
                <div class="form-label">
                  <label class="control-label">SMS認証用電話番号</label>
                </div>
                <div
                  class="form-item align-text">
                  {{ formatMobileNumber }}
                </div>
                <span class="form-item-text--inline">この番号は変更できません。<br />
                  変更が必要な場合は<a
                    href="/client/contact"
                    target="_blank"
                    style="color: blue;text-decoration: underline;">こちら</a>からお問い合わせください。
                </span>
              </div>
              <div class="form-group">
                <div class="form-label">
                  <label class="control-label">住所</label>
                </div>
                <div
                  class="form-item">
                  {{ item.company.postal_code | zipFormat }}<br />
                  {{ item.company.prefecture }}
                  {{ item.company.address1 }}<br />
                  {{ item.company.address2 }}
                </div>
              </div>
              <div>
                <template v-if="item.company.bank_name">
                  <div
                    class="form-group">
                    <div class="form-label">
                      <label class="control-label">銀行名</label>
                    </div>
                    <div
                      class="form-item form-item--change-btn">
                      {{ item.company.bank_name }}
                      <router-link
                        :to="{ name: 'bank-edit' }"
                        class="c-btn c-btn--narrow">
                        {{ item.company.bank_name ? '変更する' : '登録する' }}
                        <span class="c-btn__icon-arrow"></span>
                      </router-link>
                    </div>
                  </div>
                  <div
                    class="form-group">
                    <div class="form-label">
                      <label class="control-label">支店名</label>
                    </div>
                    <div
                      class="form-item">
                      {{ item.company.bank_branch_name }}
                    </div>
                  </div>
                  <div
                    class="form-group">
                    <div class="form-label">
                      <label class="control-label">口座種別</label>
                    </div>
                    <div
                      class="form-item">
                      {{ item.company.bank_account_type | toAccountType }}
                    </div>
                  </div>
                  <div
                    class="form-group">
                    <div class="form-label">
                      <label class="control-label">口座番号</label>
                    </div>
                    <div
                      class="form-item">
                      {{ item.company.bank_account_code }}
                    </div>
                  </div>
                  <div
                    class="form-group">
                    <div class="form-label">
                      <label class="control-label">口座名義</label>
                    </div>
                    <div
                      class="form-item">
                      {{ item.company.bank_account_name }}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="form-group">
                    <div class="form-label">
                      <label class="control-label">銀行名</label>
                    </div>
                    <div
                      class="form-item form-item--change-btn">
                      未登録
                      <router-link
                        :to="{ name: 'bank-edit' }"
                        class="c-btn c-btn--narrow">
                        登録する
                        <span class="c-btn__icon-arrow"></span>
                      </router-link>
                    </div>
                  </div>
                </template>
                <div
                  class="form-group">
                  <div class="form-label">
                    <label class="control-label">適格請求書発行事業者情報</label>
                  </div>
                  <div
                    class="form-item form-item--change-btn">
                    <div
                      v-if="item.company.invoice">
                      {{ item.company.invoice.registrated_number }}
                      /
                      {{ item.company.invoice.name }}
                      <div class="form-item-text">
                        {{ item.company.invoice.status===1?
                          '変更する場合は、お問合せより御連絡下さい。': 'この適格請求書発行事業者登録番号は無効です。再登録をお願い致します。' }}
                      </div>
                    </div>
                    <router-link
                      v-if="!item.company.invoice
                        || item.company.invoice.status===2"
                      :to="{ name: 'profile-edit-invoice' }"
                      class="c-btn c-btn--narrow">
                      登録する
                      <span class="c-btn__icon-arrow"></span>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-change">
                <div class="form-label">
                  <label class="control-label">メールアドレス（ID）</label>
                </div>
                <div
                  class="form-item form-item--change-btn">
                  {{ item.email }}
                  <router-link
                    :to="{ name: 'profile-edit-mail' }"
                    class="c-btn c-btn--narrow">
                    変更する
                    <span class="c-btn__icon-arrow"></span>
                  </router-link>
                </div>
              </div>
              <div class="form-group form-group-change">
                <div class="form-label">
                  <label class="control-label">パスワード</label>
                </div>
                <div class="form-item form-item--change-btn">
                  ● ● ● ● ● ● ●
                  <router-link
                    :to="{ name: 'profile-edit-password' }"
                    class="c-btn c-btn--narrow">
                    変更する
                    <span class="c-btn__icon-arrow"></span>
                  </router-link>
                </div>
              </div>
              <div class="form-group form-group-change">
                <div class="form-label">
                  <label class="control-label">お知らせメール受信</label>
                </div>
                <div class="form-item-inline">
                  <div class="radio">
                    <label for="receive_information_mail">
                      <input
                        id="receive_information_mail"
                        v-model="item.send_information"
                        type="radio"
                        name="information_mail"
                        :value="1"
                        checked>
                      <div class="option-input"></div> 受け取る
                    </label>
                  </div>
                  <div class="radio">
                    <label for="not_receive_information_mail">
                      <input
                        id="not_receive_information_mail"
                        v-model="item.send_information"
                        type="radio"
                        :value="0"
                        name="information_mail">
                      <div class="option-input"></div> 受け取らない
                    </label>
                  </div>
                </div>
                <div
                  class="c-btn c-btn--narrow"
                  @click.prevent="onChangeSendInformationFlag">
                  変更する
                  <span class="c-btn__icon-arrow"></span>
                </div>
              </div>
              <div
                v-if="appName === 'Zu-MAP'"
                class="form-group form-group-change">
                <div class="form-label">
                  <label class="control-label">放送二次使用料分配サービス<br>(レコード製作者)利用規約</label>
                </div>
                <div class="form-item-inline">
                  <div class="radio">
                    <label for="secondary_usage_fee_for_broadcasts_terms">
                      <input
                        id="secondary_usage_fee_for_broadcasts_terms"
                        v-model="item.company.secondary_usage_fee_for_broadcasts_terms_agreed"
                        type="radio"
                        name="secondary_usage_fee_for_broadcasts_terms"
                        :value="1"
                        :checked="item.company.secondary_usage_fee_for_broadcasts_terms_agreed === 1"
                        :disabled="item.company.secondary_usage_fee_for_broadcasts_terms_agreed === 1">
                      <div class="option-input"></div> 同意する
                    </label>
                  </div>
                  <div class="radio">
                    <label for="not_secondary_usage_fee_for_broadcasts_terms">
                      <input
                        id="not_secondary_usage_fee_for_broadcasts_terms"
                        v-model="item.company.secondary_usage_fee_for_broadcasts_terms_agreed"
                        type="radio"
                        :value="0"
                        name="secondary_usage_fee_for_broadcasts_terms"
                        :checked="item.company.secondary_usage_fee_for_broadcasts_terms_agreed === 0"
                        :disabled="item.company.secondary_usage_fee_for_broadcasts_terms_agreed === 1">
                      <div class="option-input"></div> 同意しない
                    </label>
                  </div>
                </div>
                <div
                  class="c-btn c-btn--narrow"
                  @click.prevent="onChangeSecondaryUsageFeeForBroadcastsAgree">
                  変更する
                  <span class="c-btn__icon-arrow"></span>
                </div>
              </div>
              <div
                v-if="isBtoC"
                class="form-group form-group-change">
                <div class="form-label"></div>
                <div class="form-item form-item--change-btn">
                  <span
                    v-if="isBtoC && item.is_scholarship!==1"
                    class="c-btn c-btn--text"
                    @click="onWithdrawClicked">
                    退会する
                  </span>
                </div>
              </div>
              <!-- permission = 9 かつ is_consumer = 1: オートコンプリート -->
              <div
                v-if="useAutocomplete"
                class="form-group form-group-change">
                <div class="form-label">
                  <label class="control-label">ユーザ変更</label>
                </div>
                <div class="form-item form-item--change-btn autocomplete-container">
                  <input
                    v-model="searchKeyword"
                    type="text"
                    class="form-control autocomplete-input"
                    placeholder="会社名を3文字以上入力"
                    @input="onSearchInput">
                  <!-- 検索中インジケーター -->
                  <span
                    v-if="isSearching"
                    class="search-indicator">検索中...</span>
                  <!-- 検索結果ドロップダウン -->
                  <div
                    v-if="searchResults.length > 0"
                    class="autocomplete-dropdown">
                    <div
                      v-for="company in searchResults"
                      :key="company.id"
                      class="autocomplete-item"
                      @click="selectCompany(company)">
                      <div class="company-name">{{ company.name }}</div>
                      <div class="company-info">
                        ユーザ氏名: {{ formatContactName(company.contact_name) }} /
                        登録日: {{ formatCreatedAt(company.created_at) }}
                      </div>
                    </div>
                  </div>
                  <!-- 検索結果なしメッセージ -->
                  <div
                    v-if="searchKeyword.length >= 3 && !isSearching && searchResults.length === 0 && !selectedCompany"
                    class="autocomplete-no-result">
                    該当する会社が見つかりません
                  </div>
                  <a
                    href="#"
                    class="c-btn c-btn--narrow"
                    :class="{ 'c-btn--disabled': !canChangeCompany }"
                    @click.prevent="canChangeCompany && onCompanyChangeClicked()">
                    変更する
                    <span class="c-btn__icon-arrow"></span>
                  </a>
                </div>
              </div>
              <!-- is_consumer = 0 または permission < 9: 従来のプルダウン -->
              <div
                v-else-if="item.permission >= 5"
                class="form-group form-group-change">
                <div class="form-label">
                  <label class="control-label">
                    {{ isBtoB ? '所属法人変更' : 'ユーザ変更' }}
                  </label>
                </div>
                <div class="form-item form-item--change-btn">
                  <select
                    v-model="change_company_id"
                    class="form-control c-select">
                    <option
                      v-for="(company, index) in companies"
                      :key="index"
                      :value="company.id">
                      {{ company.name }}
                    </option>
                  </select>
                  <a
                    href="#"
                    class="c-btn c-btn--narrow"
                    @click.prevent="onCompanyChangeClicked">
                    変更する
                    <span class="c-btn__icon-arrow"></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="c-btn-wrap">
              <router-link
                :to="{ name: 'index' }"
                class="c-btn c-btn--back">
                戻る
                <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <confirm-dialog
      name="deleteArtist"
      :is-shown="showDialog"
      :default-button-title="'決済情報を更新する'"
      :cancel-button-title="false"
      title="解約手続きを行うことができません"
      @closed="showDialog = false"
      @default-clicked="onDefaultClicked">
      <template #body>
        <template v-if="subscriptionDefaulted">
          決済情報の更新を行っていただくまで、<br>サブスクプランの解約はできません
        </template>
        <template v-if="subscriptionCarrierFeePending">
          サブスクプランの解約を行うためには<br>決済情報を更新する必要があります。
        </template>
      </template>
    </confirm-dialog>
    <confirm-dialog
      name="deleteArtist2"
      :is-shown="showDialog2"
      :default-button-title="'決済情報を更新する'"
      :cancel-button-title="false"
      title="退会手続きを行うことができません"
      @closed="showDialog2 = false"
      @default-clicked="onDefaultClicked">
      <template #body>
        <template v-if="subscriptionDefaulted">サブスクプランのお支払いが確認できるまでは<br>退会することはできません。</template>
        <template v-if="subscriptionCarrierFeePending">退会するためには<br>決済情報を更新する必要があります。</template>
        <br>
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment/moment'
import HeaderBar from '../HeaderBar'
import ConfirmDialog from '../../../components/ConfirmDialog'

export default {
  name: 'Profile',
  components: {
    HeaderBar,
    ConfirmDialog,
  },
  filters: {
    toAccountType: (value) => (parseInt(value, 10) === 1 ? '当座' : '普通'),
    zipFormat: (value) => (value ? `〒${value.substr(0, 3)}-${value.substr(3)}` : ''),
  },
  data() {
    return {
      // logoutDialogIsShown: false,
      item: {
        name: '',
        email: '',
        send_information: null,
        company: {
          name: '',
          representative_name: '',
          establishment_date: '',
          telephone: '',
          postal_code: '',
          address: '',
          bank_name: '',
          bank_branch_name: '',
          bank_account_type: '',
          bank_account_code: '',
          bank_account_name: '',
          contact_name: '',
          secondary_usage_fee_for_broadcasts_terms_agreed: -2,
        },
      },
      companies: [],
      change_company_id: null,
      settlement_method: '',
      contract_plan: 0,
      showDialog: false,
      showDialog2: false,
      // オートコンプリート用
      searchKeyword: '',
      searchResults: [],
      selectedCompany: null,
      isSearching: false,
      searchTimeout: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['isSubscriber', 'subscriptionDefaulted', 'subscriptionCarrierFeePending']),
    contract_plan_name() {
      if (this.contract_plan > 0) {
        return this.contract_plan === 1 ? '1回払いきりプラン' : 'サブスクプラン'
      }
      return '未契約'
    },
    // remove country code from saved mobile number
    formatMobileNumber() {
      const mobile = this.item.mobile_number
      if (mobile) {
        return `0${mobile.replace(/^(\+81)/, '')}`
      }
      return ''
    },
    // permission = 9 かつ is_consumer = 1 のみオートコンプリート
    useAutocomplete() {
      return this.item.permission === 9 && this.isBtoC
    },
    // 変更ボタンの活性制御
    canChangeCompany() {
      if (this.useAutocomplete) {
        return this.selectedCompany !== null
      }
      return true
    },
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const response = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      this.item = response.data
      this.item.dob = this.item.dob !== null ? moment(this.item.dob).format('YYYY-MM-DD') : ''
      this.change_company_id = this.item.company.id
      this.send_information = this.item.send_information
      if (!this.useAutocomplete) {
        this.fetchCompanies()
      }
      if (this.isBtoC) {
        this.contract_plan = this.$store.state.auth.contract_plan
        if (this.contract_plan === 2) {
          this.settlement_method = this.$store.state.auth.subscription.settlement_method.name
        }
      }
    },
    async fetchCompanies() {
      const params = { is_consumer: this.isBtoC ? 1 : 0, licensor_domain: window.location.hostname }
      const response = await window.axios.get('/api/client/companies', { params })
      this.companies = response.data
    },
    async onCompanyChangeClicked() {
      if (this.item.permission < 5) {
        return
      }
      await window.axios.put('/api/client/user/change-company', { company_id: this.change_company_id })
      window.location.href = '/client/'
    },
    async onChangeSendInformationFlag() {
      await window.axios.put('/api/client/user/change-send-information', { send_information: this.item.send_information })
    },
    async onChangeSecondaryUsageFeeForBroadcastsAgree() {
      await window.axios.put('/api/client/company/change-secondary-usage-fee-for-broadcasts-agree', { secondary_usage_fee_for_broadcasts_terms_agreed: this.item.company.secondary_usage_fee_for_broadcasts_terms_agreed })
    },
    onClickGoToCancel() {
      if (this.subscriptionDefaulted || this.subscriptionCarrierFeePending) {
        this.showDialog = true
      } else {
        this.$router.push({ name: 'subscription-cancellation' })
      }
    },
    onDefaultClicked() {
      this.$router.push({ name: 'settlement-method-change' })
    },
    onWithdrawClicked() {
      if (this.subscriptionDefaulted || this.subscriptionCarrierFeePending) {
        this.showDialog2 = true
      } else {
        this.$router.push({ name: 'account-withdrawal' })
      }
    },
    // オートコンプリート: debounce付き検索
    onSearchInput() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.selectedCompany = null

      if (this.searchKeyword.length < 3) {
        this.searchResults = []
        return
      }

      this.searchTimeout = setTimeout(async () => {
        this.isSearching = true
        try {
          const response = await window.axios.get('/api/client/companies/search', {
            params: { keyword: this.searchKeyword },
          })
          this.searchResults = response.data
        } finally {
          this.isSearching = false
        }
      }, 500)
    },
    // オートコンプリート: 候補選択
    selectCompany(company) {
      this.selectedCompany = company
      this.searchKeyword = company.name
      this.change_company_id = company.id
      this.searchResults = []
    },
    // オートコンプリート: contact_name表示用フォーマット
    formatContactName(name) {
      return name || '未設定'
    },
    // オートコンプリート: 日付表示用フォーマット
    formatCreatedAt(date) {
      return date ? moment(date).format('YYYY-MM-DD') : ''
    },
  },
}
</script>

<style scoped>
.profile-heading__pic {
  background: url(../../../../../public/img/common/account_pic.png) no-repeat center center;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  background-size: contain;
}
.profile-heading__pic img {
  height: 100%;
}
.align-text {
  display: flex;
  align-items: center;
}
/* オートコンプリート用スタイル */
.autocomplete-container {
  position: relative;
}
.autocomplete-input {
  width: 300px;
}
.autocomplete-dropdown {
  position: absolute;
  top: 40px;
  left: 0;
  width: 400px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.autocomplete-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}
.autocomplete-item:hover {
  background: #f5f5f5;
}
.autocomplete-item:last-child {
  border-bottom: none;
}
.company-name {
  font-weight: bold;
  margin-bottom: 4px;
}
.company-info {
  font-size: 12px;
  color: #666;
}
.search-indicator {
  font-size: 12px;
  color: #999;
  margin-left: 8px;
}
.autocomplete-no-result {
  position: absolute;
  top: 40px;
  left: 0;
  width: 400px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px 12px;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  color: #999;
  font-size: 14px;
}
.c-btn--disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
